import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bar-chart-ghost-card',
  templateUrl: './bar-chart-ghost-card.component.html',
  styleUrls: ['./bar-chart-ghost-card.component.css']
})
export class BarChartGhostCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-ghost-card-module/bar-chart-ghost-card/bar-chart-ghost-card.component.ts